import SecureLS from "secure-ls";
// [DEMO] 기존 암호화 데이터와의 충돌 방지 (Hoisting 방지를 위해 최상단 실행)
localStorage.clear();

export const ls = new SecureLS({
  encodingType: "none",
  isCompression: false,
});
